import { Container, Row, Col, Image } from "react-bootstrap";
import '../App.css';
import {
    LightgalleryProvider,
    LightgalleryItem
} from "react-lightgallery";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExpand } from '@fortawesome/free-solid-svg-icons'

const PhotoItem = ({ image, thumb, group }) => (
    <LightgalleryItem group={group} src={image} thumb={thumb}>
        <div className="gallery-img-wrapper">
            <Image src={thumb} className="gallery-img" />
            <div className="overlay">
                <div className="overlay-content">
                    <FontAwesomeIcon icon={faExpand} size="3x" />
                </div>
            </div>
        </div>
    </LightgalleryItem>
);

const IMAGES = [
    [
        "/images/gallery/01.png",
        "/images/gallery/thumb01.png",
    ],
    [
        "/images/gallery/02.png",
        "/images/gallery/thumb02.png",
    ],
    [
        "/images/gallery/03.png",
        "/images/gallery/thumb03.png",
    ],
    [
        "/images/gallery/04.png",
        "/images/gallery/thumb04.png",
    ],
    [
        "/images/gallery/05.png",
        "/images/gallery/thumb05.png",
    ],
    [
        "/images/gallery/06.png",
        "/images/gallery/thumb06.png",
    ],
    [
        "/images/gallery/07.jpg",
        "/images/gallery/thumb07.jpg",
    ],
    [
        "/images/gallery/08.jpg",
        "/images/gallery/thumb08.jpg",
    ],
    [
        "/images/gallery/09.jpg",
        "/images/gallery/thumb09.jpg",
    ],
    [
        "/images/gallery/10.jpg",
        "/images/gallery/thumb10.jpg",
    ],
    [
        "/images/gallery/11.jpg",
        "/images/gallery/thumb11.jpg",
    ],
    [
        "/images/gallery/12.jpg",
        "/images/gallery/thumb12.jpg",
    ],
    [
        "/images/gallery/13.jpg",
        "/images/gallery/thumb13.jpg",
    ],
    [
        "/images/gallery/14.jpg",
        "/images/gallery/thumb14.jpg",
    ],
    [
        "/images/gallery/15.jpg",
        "/images/gallery/thumb15.jpg",
    ],
    [
        "/images/gallery/16.jpg",
        "/images/gallery/thumb16.jpg",
    ],
    [
        "/images/gallery/17.jpg",
        "/images/gallery/thumb17.jpg",
    ],
    [
        "/images/gallery/18.jpg",
        "/images/gallery/thumb18.jpg",
    ],
    [
        "/images/gallery/19.jpg",
        "/images/gallery/thumb19.jpg",
    ],
    [
        "/images/gallery/20.jpg",
        "/images/gallery/thumb20.jpg",
    ],
];

function GalleryScreen() {
    return (
        <Container className="mt-5 pb-5 mb-5">
            <Row>
                <Col>
                    <LightgalleryProvider>
                        <Row className="gallery-row">
                            {
                                IMAGES.map((p, idx) => (
                                    <Col key={'group1' + idx} xs={6} md={4} lg={3} className="gallery-col">
                                        <PhotoItem image={p[0]} thumb={p[1]} group="group1" />
                                    </Col>
                                ))
                            }
                        </Row>
                    </LightgalleryProvider>
                </Col>
            </Row>
        </Container>
    );
}

export default GalleryScreen;
